import { Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-datepicker/dist/react-datepicker.css";
import {
  LogInForm,
  ForgotPasswordForm,
  ResetPasswordForm,
  ForgetPasswordFormLink,
} from "./authentication";
import {
  Home,
  AgentsList,
  AddAgent,
  EditAgent,
  ListingList,
  AddListing,
  EditListing,
  Marketing,
  AgencyList,
  AddAgency,
  EditAgency,
  UserList,
  AdvertiseList
} from "./Pages";
import { Erro404 } from "./components";
import "react-tooltip/dist/react-tooltip.css";
import AdvertiseAdsList from "./Pages/Advertise/AdvertiseAdsList";
import Blog from "./Pages/Blog/Blog";
import AddBlog from "./Pages/Blog/AddBlog";
import EditBlog from "./Pages/Blog/EditBlog";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";

function App() {
  return (
    <>
      <Routes>
        {/* 🔐 Protected Routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        } />

        <Route path="/agency" element={
          <ProtectedRoute>
            <AgencyList />
          </ProtectedRoute>
        } />

        <Route path="/agency/add" element={
          <ProtectedRoute>
            <AddAgency />
          </ProtectedRoute>
        } />

        <Route path="/agency/edit/:id" element={
          <ProtectedRoute>
            <EditAgency />
          </ProtectedRoute>
        } />

        <Route path="/listings" element={
          <ProtectedRoute>
            <ListingList />
          </ProtectedRoute>
        } />

        <Route path="/listings/add/:type" element={
          <ProtectedRoute>
            <AddListing />
          </ProtectedRoute>
        } />

        <Route path="/listings/edit/:id" element={
          <ProtectedRoute>
            <EditListing />
          </ProtectedRoute>
        } />

        <Route path="/agents" element={
          <ProtectedRoute>
            <AgentsList />
          </ProtectedRoute>
        } />

        <Route path="/agents/add" element={
          <ProtectedRoute>
            <AddAgent />
          </ProtectedRoute>
        } />

        <Route path="/agents/edit/:id" element={
          <ProtectedRoute>
            <EditAgent />
          </ProtectedRoute>
        } />

        <Route path="/user" element={
          <ProtectedRoute>
            <UserList />
          </ProtectedRoute>
        } />

        <Route path="/advertise" element={
          <ProtectedRoute>
            <AdvertiseList />
          </ProtectedRoute>
        } />

        <Route path="/advertiseList" element={
          <ProtectedRoute>
            <AdvertiseAdsList />
          </ProtectedRoute>
        } />

        <Route path="/blog" element={
          <ProtectedRoute>
            <Blog />
          </ProtectedRoute>
        } />

        <Route path="/blog/add" element={
          <ProtectedRoute>
            <AddBlog />
          </ProtectedRoute>
        } />

        <Route path="/blog/:id" element={
          <ProtectedRoute>
            <EditBlog />
          </ProtectedRoute>
        } />

        {/* 🌐 Public Routes */}
        <Route path="/log-in" element={
          <PublicRoute>
            <LogInForm />
          </PublicRoute>
        } />

        <Route path="/auth/forgot-password" element={
          <PublicRoute>
            <ForgotPasswordForm />
          </PublicRoute>
        } />

        <Route path="/auth/reset-password/:id" element={
          <ProtectedRoute>
            <ResetPasswordForm />
          </ProtectedRoute>
        } />

        <Route path="/auth/reset-password/:id/:token" element={
          <PublicRoute>
            <ForgetPasswordFormLink />
          </PublicRoute>
        } />

        {/* 404 */}
        <Route path="*" element={<Erro404 />} />
      </Routes>
    </>
  );
}

export default App;
